import VisitorInfoPage from '../visitas/pages/VisitorInfoPage.vue';
import { laisPath } from '../laisRouteHelpers';

const clientProfileRoute = {
  path: laisPath('/client-profile/:visitorId'),
  name: 'client-profile',
  component: VisitorInfoPage,
  meta: { referenceAuthenticated: true },
};

export default clientProfileRoute;
